// extracted by mini-css-extract-plugin
export var card = "_62-1";
export var container = "_62-0";